














import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

import { Meta } from '@/decorators';
import store from '@/store';

import BackgroundImage from '@/components/ui/BackgroundImage.vue';
import FleetItem from '@/components/blocks/fleet/FleetItem.vue';

import IFleet from '@/store/modules/fleet/types/IFleet';
import IFleetMeta from '@/store/modules/fleet/types/IFleetMeta';
import IFleetHeader from '@/store/modules/fleet/types/IFleetHeader';

async function dataHook(to: Route, from: Route, next: (callback?: any) => void ) {
  try {
    await store.dispatch('fleet/load');
    next(true);
  } catch (error) {
    store.commit('app/error', error, { root: true });
    next({ path: '/error' });
  }
}

@Component({
  components: {
    BackgroundImage,
    FleetItem,
  },
})
export default class VehicleFleet extends Vue {
  private get meta(): IFleetMeta {
    return this.$store.state.fleet.meta;
  }

  private get header(): IFleetHeader {
    return this.$store.state.fleet.header;
  }

  private get fleet(): IFleet[] {
    return this.$store.state.fleet.fleet;
  }

  @Meta
  public metaInfo() {
    return {
      title: this.meta.title,
       meta: [{
        vmid: 'description',
        name: 'description',
        content: this.meta.description,
      }],
    };
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (callback?: any) => void) {
    await dataHook(to, from, next);
  }
}
